import React from 'react'
import { AdminApp, createAdmin } from '@low6/core-admin'
import { MyCustomPage } from './pages/MyCustomPage'

const app = createAdmin({
  brand: { appName: 'Partner Admin' },
  theme: { '--accent': '#3b82f6' },
  features: [
    { id: 'custom', route: '/custom', element: <MyCustomPage /> },
  ],
})

export default function App() {
  return <AdminApp config={app} />
}
